import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';

import { Rate } from '@amfam/policy/models';
import { FEATURES } from '@amfam/policy/vehicle-coverages/data-access';
import { QuoteModel } from '@amfam/shared/models';

// import * as fromRoot from '../../core/store';

@Component({
  selector: 'ds-recalculate-sidebar',
  templateUrl: './recalculate-sidebar.component.html',
  styleUrls: ['./recalculate-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RecalculateSidebarComponent {
  @Input() noOfVehicles: number;
  @Input() icons: number[];
  @Input() vehicleName: string;
  @Input() vehicleCurrentRate: Rate;
  @Output() recalculateQuote = new EventEmitter();
  @Output() resetQuote = new EventEmitter();
  @Input() quoteData: QuoteModel;
  @Input() enableResetCoverage: boolean;
  @Input() canRecalculate: boolean;
  @Input() isPartner: boolean;

  constructor(private store: Store) {}

  public recalculate() {
    this.recalculateQuote.emit(FEATURES.CHANGE);
  }
}
